import { render, staticRenderFns } from "./JurisdictionSelect.vue?vue&type=template&id=0ab2a522&scoped=true&"
import script from "./JurisdictionSelect.vue?vue&type=script&lang=js&"
export * from "./JurisdictionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab2a522",
  null
  
)

export default component.exports